// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-Bom2aPositionsTable-module__tableFrame--NUZQD {
  height: 100%;
  min-height: 50px;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-Bom2aPositionsTable-module__header--VnrNt {
  display: grid;
  overflow: hidden;
}
.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-Bom2aPositionsTable-module__body--YseWY {
  flex: 1;
  overflow: auto;
}
.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-Bom2aPositionsTable-module__cells--RqFRU {
  display: grid;
  grid-auto-rows: auto;
}
.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-Bom2aPositionsTable-module__th--cKTZP {
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  border: thin solid rgba(0, 0, 0, 0.06);
  padding: 4px 8px;
}
.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-Bom2aPositionsTable-module__posHd--c2XWj {
  background-color: #f0f0f0;
  padding: 4px 8px;
}
.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-Bom2aPositionsTable-module__td--e1HpM {
  border: thin solid rgba(0, 0, 0, 0.06);
  padding: 4px 8px;
}
.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-Bom2aPositionsTable-module__positionTitle--OEdO2 {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  padding: 4px;
}
.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-Bom2aPositionsTable-module__positionTitle--OEdO2 .src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-Bom2aPositionsTable-module__matName--XC9oo {
  flex: 1;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 160%;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsBom2a/Bom2aControl/Bom2aPositions/Bom2aPositionsTable/Bom2aPositionsTable.module.less"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,gBAAA;EACA,cAAA;EAEA,aAAA;EACA,sBAAA;AAFF;AAKA;EACE,aAAA;EACA,gBAAA;AAHF;AAMA;EACE,OAAA;EACA,cAAA;AAJF;AAOA;EACE,aAAA;EACA,oBAAA;AALF;AAQA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAEA,sCAAA;EACA,gBAAA;AAPF;AAUA;EACE,yBAAA;EACA,gBAAA;AARF;AAWA;EACE,sCAAA;EACA,gBAAA;AATF;AAYA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;AAVF;AAKA;EAQI,OAAA;EAEA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAXJ","sourcesContent":["// общий контейнер\n// пока только для прокрутки\n.tableFrame {\n  height: 100%;\n  min-height: 50px;\n  overflow: auto;\n\n  display: flex;\n  flex-direction: column;\n}\n\n.header {\n  display: grid;\n  overflow: hidden;\n}\n\n.body {\n  flex: 1;\n  overflow: auto;\n}\n\n.cells {\n  display: grid;\n  grid-auto-rows: auto;\n}\n\n.th {\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n\n  border: thin solid rgba(0, 0, 0, 0.06); // TODO\n  padding: 4px 8px;\n}\n\n.posHd {\n  background-color: #f0f0f0;\n  padding: 4px 8px;\n}\n\n.td {\n  border: thin solid rgba(0, 0, 0, 0.06); // TODO\n  padding: 4px 8px;\n}\n\n.positionTitle {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  align-items: center;\n  padding: 4px;\n\n  .matName {\n    flex: 1;\n\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 160%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableFrame": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-Bom2aPositionsTable-module__tableFrame--NUZQD`,
	"header": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-Bom2aPositionsTable-module__header--VnrNt`,
	"body": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-Bom2aPositionsTable-module__body--YseWY`,
	"cells": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-Bom2aPositionsTable-module__cells--RqFRU`,
	"th": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-Bom2aPositionsTable-module__th--cKTZP`,
	"posHd": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-Bom2aPositionsTable-module__posHd--c2XWj`,
	"td": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-Bom2aPositionsTable-module__td--e1HpM`,
	"positionTitle": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-Bom2aPositionsTable-module__positionTitle--OEdO2`,
	"matName": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-Bom2aPositionsTable-module__matName--XC9oo`
};
export default ___CSS_LOADER_EXPORT___;
